import ChatDetailInfo from '@/screens/ChatDetailInfo';

export default function PrivateChatChatIdInfoIndexRoute() {
  return <ChatDetailInfo />;
}
